import React from "react";
import Card from "@mui/joy/Card";
import Typography from "@mui/joy/Typography";
import { PromoCodeUsagesTable } from "../../adCampaigns/PromoCodeUsagesTable";
import { AdminPromoCodeUsage } from "../../../models/promoCode";

type Props = {
    promoCodes?: AdminPromoCodeUsage[];
};

/** Промокоды пользователя: активный, израсходованный (что сработало и во что обошлось), заменённые. */
export function UserPromoCodesCard({ promoCodes }: Props) {
    if (!promoCodes || promoCodes.length === 0) {
        return null;
    }

    return (
        <Card>
            <Typography level="title-md">Промокоды</Typography>
            <Typography level="body-xs" color="neutral">
                Условия зафиксированы при активации. Бонус срабатывает один раз — на первом подходящем событии.
            </Typography>
            <PromoCodeUsagesTable items={promoCodes} showUser={false} />
        </Card>
    );
}
